export default __webpack_public_path__ + "static/media/Hair_7_M_C4.8a71d504.svg";